<template>
  <div
    v-bind:style="showModal ? {display: 'block'} : {display: 'none'}"
    class="modal"
    id="infoModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="myModalLabel"
    aria-hidden="true"
    style="display: none;"
  >
    <div class="modal-dialog modal-info modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title">Requerimiento #{{requeriment.id}} :: Camiones</h4>
          <button
            @click="close"
            class="close"
            type="button"
            data-dismiss="modal"
            aria-label="Close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group form-inline pull-left">
            <ul class="nav nav-tabs">
              <li class="nav-item">
                <a class="nav-link active" @click="trucksByService(1)">Inland</a>
              </li>
              <li class="nav-item">
                <a class="nav-link active" @click="trucksByService(0)">Porteo</a>
              </li>
            </ul>
          </div>
          <div class="form-group form-inline pull-right">
            <input v-model="search" type="search" class="form-control" placeholder="Buscar camión"> &nbsp;
          </div>
          <div class="table-responsive tableFixHead">
            <table class="table table-bordered table-hover table-striped">
              <thead>
                <tr>
                  <th>Placa</th>
                  <th>Conductor</th>
                  <th>Servicio</th>
                  <th>Características</th>
                  <th>Citas en proceso</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(truck,k) in filteredTruckList"
                  v-on:click="truckSelected=truck"
                  v-bind:class="truckSelected.id==truck.id ? 'bg-success':''"
                  :key="k"
                  href="#"
                  active
                  class="flex-column align-items-start"
                >
                  <td>{{truck.plate}}</td>
                  <td>{{truck.driver ? `${truck.driver.name} ${truck.driver.last_name}` : ''}}</td>
                  <td>{{truck.service.name}}</td>
                  <td>
                    <div v-for="(item, j) in truck.types" :key="j">
                      <span class="badge badge-info">{{item.name}}</span>
                    </div>
                  </td>
                  <td>
                    <div v-for="(item, j) in truck.requeriments" :key="j">
                      <span
                        class="badge badge-default"
                      >{{`#${item.id} `}}-{{ ( item.operation_id ? item.appointment_date : item.date ) | formatDateTime}}</span>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <div v-if="requeriment.operation_id && !isDpw" class="form-group form-inline pull-left">
            <div class="form-group">
              <date-picker
                v-model="appointmentDate"
                lang="es"
                type="datetime"
                required
                format="DD/MM/YYYY HH:mm"
                placeholder="Ingresar cita"
                :time-picker-options="{ start: '00:00', step: '01:00', end: '23:55' }"
              ></date-picker>
            </div>
          </div>
          <div class="form-group form-inline pull-rigth">
            <button @click="assignTruck()" type="button" class="btn btn-primary">Asignar</button>&nbsp;
            <button
              @click="close"
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
            >Cerrar</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "@/helpers/api";
import constants from "@/constants";
import moment from "moment";
export default {
  name: "ModalTrucks",
  props: ["requeriment", "statuses", "showModal", "isDpw", "portage"],
  data() {
    return {
      truckSelected: {},
      trucks: [],
      serviceTrucks: [],
      search: "",
      appointmentDate: null
    };
  },
  computed: {
    filteredTruckList() {
      return this.serviceTrucks.filter(truck => {
        let plateCondition = truck.plate
          .toLowerCase()
          .includes(this.search.toLowerCase());
        let characCondition = truck.types.some(tt =>
          tt.name.toLowerCase().includes(this.search.toLowerCase())
        );

        return plateCondition || characCondition;
      });
    }
  },
  mounted() {
    this.getTrucks();
  },
  methods: {
    showError(label) {
      this.$toastr.error(label, "Error", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    showSuccess(label) {
      this.$toastr.success(label, "Éxito", {
        positionClass: "toast-top-center",
        closeButton: true
      });
    },
    getTrucks() {
      api.get("/trucks").then(response => {
        this.trucks = response.trucks.filter(t => t.active);
        this.serviceTrucks = this.trucks;
      });
    },
    assignTruck() {
      if (!this.truckSelected.id) {
        this.showError("Debes seleccionar un camión del listado.");
        return;
      }

      let data = {
        truck_id: this.truckSelected.id,
        driver_id: this.truckSelected.driver_id,
        status_id: this.statuses.find(st => st.code === constants.ASIGNADO).id
      };
      
      if(this.requeriment.status.code !== constants.APROBADO){
        delete data.status_id
      }

      if(this.requeriment.operation_id){
        let min_time = moment(this.appointmentDate).add(-this.portage.port.cycle_time * this.portage.port.timeframe, 'minutes').format('YYYY-MM-DD HH:mm:00')
        let max_time = moment(this.appointmentDate).add(this.portage.port.cycle_time * this.portage.port.timeframe, 'minutes').format('YYYY-MM-DD HH:mm:00')

        let search = this.truckSelected.requeriments.some(rq_truck => {
          return rq_truck.appointment_date >= min_time && rq_truck.appointment_date <= max_time
        })
  
        if(search && !confirm('El camión tiene asignada una cita que, considerando los tiempos de ciclo, probablemente no alcanzará a cumplir la cita que indicas, ¿Seguro deseas asignar?')){
          return false
        }
      }

      //if its APM, make appointment date required
      if (this.requeriment.operation_id && !this.isDpw) {
        if (!this.appointmentDate) {
          this.showError("Fecha de cita obligatoria para APM");
          return false;
        }

        if(moment(this.appointmentDate).format('YYYY-MM-DD HH:mm:ss') > this.portage.cutoff){
          this.showError(`No es posible programar una cita posterior al CUTOFF: ${moment(this.portage.cutoff).format('DD/MM/YYYY HH:mm')}`);
          return false;
        }

        data.appointment_date = moment(this.appointmentDate).format(
          "YYYY-MM-DD HH:mm:00"
        );
      }

      api.put(`/requeriments/${this.requeriment.id}`, data).then(response => {
        if (response.success) {
          api
            .post("/action_logs/", {
              rq_id: this.requeriment.id,
              comments: `Asignado a camión ${this.truckSelected.plate}`
            })
            .then(res => console.log(res));
          this.showSuccess("Camión asignado exitosamente.");
          this.getTrucks();
          if (data.driver_id) {
            let data_push = {
              user_id: data.driver_id,
              headings: "Requerimiento asignado",
              contents:
                "Se le ha asignado un requerimiento. Revise su bandeja.",
              data: { requeriment_id: this.requeriment.id }
            };
            api.post("/send_push", data_push).then(response => {
              console.log(response);
            });
          }

          this.$socket.emit("updateRequerimentServer", response.requeriment);
          this.close(null, response.requeriment);
        }
      });
    },
    trucksByService(inland) {
      let code = "";
      if (inland) code = "INL";
      else code = "PORT";
      this.serviceTrucks = this.trucks.filter(t => t.service.code === code);
    },
    close(e, rq = null) {
      this.truckSelected = {};
      this.appointmentDate = null;
      this.$emit("close", rq);
    }
  }
};
</script>